import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import "./Widget.scss";

const Widget = ({
    title,
    subtitle,
    link,
    linkLabel,
    onLinkClick,
    children,
    className,
    empty,
    dataTestId,
}) => (
    <div className={`${className} widget flex flex-column`} data-testid={dataTestId}>
        {(title || subtitle || link) && (
            <div className="flex w-full justify-between items-start">
                <div className="widget__title-wrap">
                    <h3 className="widget__title text-lg">{title}</h3>
                    {subtitle && <h4 className="widget__subtitle text-sm">{subtitle}</h4>}
                </div>
                {link && (
                    <Link to={link} className="default-link" onClick={onLinkClick}>
                        {linkLabel}
                    </Link>
                )}
            </div>
        )}
        {!!empty && <Widget.Empty />}
        {children}
    </div>
);

Widget.defaultProps = {
    title: "",
    link: null,
    linkLabel: "Show all",
    onLinkClick: undefined,
    className: "",
    subtitle: null,
    children: null,
    empty: false,
    dataTestId: null,
};

Widget.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    link: PropTypes.string,
    linkLabel: PropTypes.string,
    onLinkClick: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.oneOfType([PropTypes.any]),
    empty: PropTypes.bool,
    dataTestId: PropTypes.string,
};

Widget.Empty = () => (
    <div className="widget__empty">
        <p className="text-sm text-dark-grey text-secondary">
            No data to display.
            <br />
            Run some scripts.
        </p>
    </div>
);

export default Widget;
